import React from "react";
import connect from "react-redux/es/connect/connect";
import {
    GLOBAL_PROJECT_TYPE_CHAMBER,
} from "../../lib/types";
import { scaleStage, positionStage, switchPanning } from "../../actions/viewport-actions";
import { CommandBarButton, Slider } from "office-ui-fabric-react";
import "./index.css";
import { clearRulersOnScreen } from "../../actions/drawingtoolbar-actions";
import ADSDefaultButton from "../ADSDefaultButton/ADSDefaultButton";

class Toolbox extends React.Component{
    get zoomLabel() {
        const percentageValue = Math.round(this.props.viewportScaleX * 100 * 100) / 100;
        return `${percentageValue}%`;
    }

    handleZoom( value ) {
        this.props.clearRulersOnScreen(); //Clears scale and measurement rulers
        value = value.step(0.25).clamp(0.1, 5);

        const oldScaleX = this.props.viewportScaleX;
        const oldScaleY = this.props.viewportScaleY;
        let stage = this.props.stageNode.getStage();

        // NOTE: Make sure you find the old mouse point before you set the scale
        const oldMousePoint = {
            x: stage.width() / 2 / oldScaleX - stage.x() / oldScaleX,
            y: stage.height() / 2 / oldScaleY - stage.y() / oldScaleY,
        };

        let newScale = value;

        this.props.scaleStage(newScale, newScale);

        // NOTE: Find the new mouse point with the new scale applied
        const newMousePoint = {
            x: -( oldMousePoint.x - stage.width() / 2 / newScale ) * newScale,
            y: -( oldMousePoint.y - stage.height() / 2 / newScale ) * newScale,
        };
        this.props.positionStage(newMousePoint.x, newMousePoint.y);
    }

    render() {
        const {
            lang,
            content,
        } = this.props;

        return (
            <React.Fragment>
                <div className="ms-Grid-row" style={{ margin: "0px", backgroundColor: '#F5FAFC' }}>
                    <div className="ms-Grid-col ms-sm12 ms-md12 ms-lg12 ms-xl12 ms-xxl6 ms-xxxl6 zoom-icon-row"
                         style={{ paddingTop: "8px", textAlign: "center", minWidth: "140px",
                             backgroundColor: '#F5FAFC' }}>
                        <CommandBarButton
                            title={content[lang].decreaseZoom}
                            iconProps={{ iconName: "ZoomOut" }}
                            className={"zoom-icon"}
                            onClick={() => {
                                this.props.clearRulersOnScreen(); //Clears scale and measurement rulers
                                this.handleZoom(this.props.viewportScaleX - 0.25);
                            }}/>
                        <CommandBarButton
                            title={content[lang].resetZoom}
                            className={"zoom-icon"}
                            iconProps={{ iconName: "Zoom" }}
                            onClick={() => {
                                this.props.clearRulersOnScreen(); //Clears scale and measurement rulers
                                this.handleZoom(1);
                            }}/>
                        <CommandBarButton
                            title={content[lang].increaseZoom}
                            iconProps={{ iconName: "ZoomIn" }}
                            className={"zoom-icon"}
                            onClick={() => {
                                this.props.clearRulersOnScreen(); //Clears scale and measurement rulers
                                this.handleZoom(this.props.viewportScaleX + 0.25);
                            }}/>
                    </div>
                    <div className="ms-Grid-col ms-sm10 ms-md10 ms-lg10 ms-xl10 ms-xxl4 ms-xxxl4 zoom-slider-row"
                         style={{ paddingTop: "4px" }}>
                        <Slider
                            max={5}
                            min={0.1}
                            step={0.25}
                            showValue={false}
                            className={"slider"}
                            value={this.props.viewportScaleX}
                            onChange={value => this.handleZoom(value)}/>
                    </div>
                    <div className="ms-Grid-col ms-sm2 ms-md2 ms-lg2 ms-xl2 ms-xxl2 ms-xxxl2 zoom-label-row" style={{ paddingTop: "7px" }}>
                        <div>{this.zoomLabel}</div>
                    </div>
                </div>
                <div className="ms-Grid-row panning-row" style={{
                    margin: "0px",
                    borderBottom: "1px solid #D3DFE5",
                    textAlign: "center",
                    paddingBottom: "4px",
                    paddingRight: "8px",
                    backgroundColor: '#F5FAFC'
                }}>
                    <hr/>
                    <ADSDefaultButton
                        className={"panning-button"}
                        disabled={this.props.scaleEdit}
                        primary={this.props.isPanning}
                        data-automation-id="enablePanning"
                        iconProps={{ iconName: "HandsFree" }}
                        text={this.props.isPanning ? content[lang].disablePanning : content[lang].enablePanning}
                        Style={{color:"white"}}
                        onClick={() => {
                            this.props.clearRulersOnScreen(); //Clears scale and measurement rulers
                            this.props.switchPanning();
                        }}
                    />
                </div>
            </React.Fragment>
        );
    }


}

const mapStateToProps = state => {
    const projectType = state.globals.projectType;
    let viewportScaleX, viewportScaleY;

    if (projectType === GLOBAL_PROJECT_TYPE_CHAMBER) {
        viewportScaleX = state.viewport.scaleX;
        viewportScaleY = state.viewport.scaleY;
    } else {
        viewportScaleX = state.viewport.scaleXPipes;
        viewportScaleY = state.viewport.scaleXPipes;
    }

    return {
        stageNode: window.konvaStage,
        lang: state.localization.lang,
        viewportScaleX: viewportScaleX,
        viewportScaleY: viewportScaleY,
        isPanning: state.viewport.isPanning,
        content: state.localization.content,
        scaleEdit: state.drawingToolbar.scaleEdit,
    };
};

const mapDispatchToProps = {
    scaleStage,
    positionStage,
    switchPanning,
    clearRulersOnScreen,
};

export default connect(
    mapStateToProps,
    mapDispatchToProps,
)(Toolbox);



// WEBPACK FOOTER //
// ./src/components/Toolbox/index.js